import { engineComponent } from "neo-common";
import { Style } from "./Style";
import { ContainerElement } from "../Graphics/ContainerElement";
import { ComponentTypes } from "../../ComponentTypes";

/**
 * TimelineStyle create container from child <elements> and holds xml nodes of frames for this element.
 * Example:
 *   <TimelineStyle Class="TimelineStyle">
 *      <Elements>
 *           <Child1 />
 *           <Child2 X="0" />
 *           ...
 *      </Elements>
 *      <TimeLine>
 *          <Frame Frame="0">
 *              <Child2 X="50" />
 *          </Frame>
 *          <Frame Frame="CASE2">
 *              <Child1 X="200" />
 *          </Frame>
 *      </TimeLine>
 *      <SoundTimeline>
 *          <Frame Frame="0">
 *              <Song Song="ID" Play="true" />
 *          </Frame>
 *          <Frame Frame="CASE2">
 *              <Song Song="ID" Play="false" />
 *          </Frame>
 *      </SoundTimeline>
 *   </TimelineStyle>
 * @class TimelineStyle
 * @extends Style
 */
@engineComponent(ComponentTypes.Style)
export class TimelineStyle extends Style {
    container: ContainerElement;

    // xml nodes added to object by fframe
    frames: Object;
    framesOriginal: Object;
    framesSounds: Object;
    framesSoundsOriginal: Object;
    outro: Element;
    outro2: Element;
    outroSounds: Element;
    outroSounds2: Element;

    constructor() {
        super();

        this.frames = {};
        this.framesOriginal = {};
        this.framesSounds = {};
        this.framesSoundsOriginal = {};
    }

    /**
     * Get attributes from xml and set up supported properties.
     * @method create
     * @param node is Element from xml
     * @return void
     */
    create(node: Element): void {
        super.create(node);

        let next: Element = node.firstElementChild;
        while (next != null) {
            switch (next.nodeName) {
                case "Elements":
                    this.container = new ContainerElement();
                    this.container.create(next);
                    break;
                case "TimeLine":
                    var nextCase: Element = next.firstElementChild;
                    while (nextCase != null) {
                        if (nextCase.hasAttribute("DynamicFrame")) {
                            if (this.frames[nextCase.getAttribute("DynamicFrame")] !== null) {
                                this.frames[nextCase.getAttribute("DynamicFrame")] = nextCase;
                            } else {
                                if (DEBUG) {
                                    this.log(
                                        "ERROR dynamic frame " +
                                            nextCase.getAttribute("DynamicFrame") +
                                            " already exist in TimelineStyle " +
                                            node.nodeName,
                                    );
                                }
                            }
                        } else if (nextCase.hasAttribute("Frame")) {
                            if (this.frames[nextCase.getAttribute("Frame")] !== null) {
                                this.frames[nextCase.getAttribute("Frame")] = nextCase;
                            } else {
                                if (DEBUG) {
                                    this.log(
                                        "ERROR case " +
                                            nextCase.getAttribute("Frame") +
                                            " already exist in switchStyle " +
                                            node.nodeName,
                                    );
                                }
                            }
                        }
                        if (nextCase.nodeName === "Outro") {
                            this.outro = nextCase;
                        }
                        if (nextCase.nodeName === "Outro2") {
                            this.outro2 = nextCase;
                        }
                        nextCase = nextCase.nextElementSibling;
                    }
                    this.framesOriginal = this.frames;
                    break;
                case "SoundTimeline":
                    var nextCase: Element = next.firstElementChild;
                    while (nextCase != null) {
                        if (nextCase.hasAttribute("DynamicFrame")) {
                            if (this.framesSounds[nextCase.getAttribute("DynamicFrame")] !== null) {
                                this.framesSounds[nextCase.getAttribute("DynamicFrame")] = nextCase;
                            } else {
                                if (DEBUG) {
                                    this.log(
                                        "ERROR dynamic frame " +
                                            nextCase.getAttribute("DynamiFrame") +
                                            " already exist in TimelineStyle " +
                                            node.nodeName,
                                    );
                                }
                            }
                        } else if (nextCase.hasAttribute("Frame")) {
                            if (this.framesSounds[nextCase.getAttribute("Frame")] !== null) {
                                this.framesSounds[nextCase.getAttribute("Frame")] = nextCase;
                            } else {
                                if (DEBUG) {
                                    this.log(
                                        "ERROR case " +
                                            nextCase.getAttribute("Frame") +
                                            " already exist in switchStyle " +
                                            node.nodeName,
                                    );
                                }
                            }
                        }
                        if (nextCase.nodeName === "Outro") {
                            this.outroSounds = nextCase;
                        }
                        if (nextCase.nodeName === "Outro2") {
                            this.outroSounds2 = nextCase;
                        }
                        nextCase = nextCase.nextElementSibling;
                    }
                    this.framesSoundsOriginal = this.framesSounds;
                    break;
            }
            next = next.nextElementSibling;
        }
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/Components/Elements/Styles/TimelineStyle.ts
 **/